import axiosInstance from "../api/axiosInstance";

// Fetch audit logs with filters/pagination
export const fetchAuditLogs = (params) => {
  return axiosInstance.get("/admin/audit-logs", { params });
};

// Fetch single log details
export const fetchAuditLogById = (id) => {
  return axiosInstance.get(`/admin/audit-logs/${id}`);
};

// Export all logs as CSV

// export const exportAuditLogs = (queryString, config = {}) => {
//   return axiosInstance.get(`/admin/audit-logs/export?${queryString}`, {
//     ...config,
//   });
// };

export const exportAuditLogs = async (params) => {
  const response = await axiosInstance.get("/admin/audit-logs/export", {
    params, // ✅ Let Axios handle query params
    responseType: "blob", // necessary for file download
    headers: { "Content-Type": undefined }, // avoid conflicts
  });
  return response;
};


